.form-subtitle {
  margin-top: calc(var(--spacer) * 2.5);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

.options-form-subtitle {
  margin-top: 2px;
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

gz-title + gz-form-field,
gz-title + gz-labeled-content,
gz-title + div {
  padding-top: 15px;
}

#action-field {
  position: relative;
  z-index: 0;
}

gz-labeled-content {
  &::part(content) {
    overflow: visible;
  }

  &::part(label) {
    --font-family: var(--font-family-secondary);
  }
}

#rules-scope-section {
  gz-radio-group {
    display: flex;
  }
}

.checkbox-with-input {
  display: flex;
  align-items: center;

  .checkbox-width {
    width: 410px;
  }

  .checkbox-width-320 {
    width: 320px;
  }

  .checkbox-width-220 {
    width: 220px;
  }
}

.action-title {
  color: var(--chart-300-icon-buttons);
}

#rule-settings-detect-by-content-section {
  margin-left: 25px;

  #rule-settings-detect-by-content-categories-section {
    margin-left: 25px;

    .container {
      display: flex;
      align-items: start;
      .firstColumn {
        width: 250px;

        #rule-settings-detect-by-content-custom-extensions-field {
          margin-left: 20px;
          width: 470px;
        }

        #rule-settings-detect-by-content-true-file-type-detection-field {
          width: 800px;
          gz-text {
            margin-top: 5px;
            margin-left: 25px;
            color: var(--chart-300-icon-buttons);
          }
        }
      }
    }
  }
}
#rule-settings-archive-scan-maximum-depth-section {
  margin-left: 25px;
}

#rules-actions-section {
  #rule-actions-primary-section {
    display: flex;
    align-items: center;

    gz-dropdown {
      --form-field-input-width: 480px;
    }

    gz-form-field + gz-form-field {
      margin-left: 25px;
    }
  }

  #rule-actions-secondary-section {
    margin-left: 20px;

    #rule-actions-append-header-value-field {
      margin-left: 25px;

      --form-field-label-width: 195px;
      &::part(form-field-label) {
        font-size: var(--body-size-medium);
        line-height: 18px;
      }
    }
  }
}

#rule-scope-to-specific-field,
#rule-scope-from-specific-field {
  margin-top: calc(var(--spacer) * -4); // remove extra space
  margin-left: 50px;
}

gz-checkbox {
  width: auto;
}

gz-labeled-content {
  height: 18px;
}

.helper-text {
  margin-top: -20px;
}
.infoText {
  color: var(--body-text-arrows-400);
  height: 40px;
  align-content: center;
  width: 90%;
}

#aggressivity-field {
  max-width: 800px;
}

#name {
  margin-bottom: -8px;
}
.module-subtitle {
  margin-top: 18px;
  margin-bottom: calc(var(--spacer) * 2);
  font-weight: 500;
  font-size: 18px;
}

.rules-form-container {
  margin-bottom: 120px;
}

#heuristics-text {
  width: 50%;
}
